import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PATH } from '@app/constants';
import { ImageOptimizerService } from '@app/services';
import { DevelopmentInfo, DevelopmentParticipations, DevelopmentPhase, ParticipationsInfo } from '@interfaces/app';

@Component({
  selector: 'mnf-cards-project-v2',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './cards-project-v2.component.html',
  styleUrl: './cards-project-v2.component.scss'
})
export class CardsProjectV2Component {

  @Input() dev: any;
  @Input() devParts: DevelopmentParticipations;
  path = PATH.ROUTE_PROJECTS_INFO;
  pathV2 = PATH.ROUTE_PROJECT_INFO_V2;

  public readonly urlBaseS3 = 'https://static.monific.com/assets/projects-images/';
  progress: string | number;
  message: string;
  textDateToInvest: string;
  maxDateToInvest: any;
  devName: string;
  actualPhase: string | number;

  constructor (
    private imageOptimizer: ImageOptimizerService
  ) { }


  ngOnInit (): void{
    this.maxDateToInvest = this.dev?.p?.maxDateToInvest;
    if (this.maxDateToInvest) {
      const daysLeftToInvest = this.calculateRestDay(this.maxDateToInvest);
      if (daysLeftToInvest <= 0) { this.textDateToInvest = 'Hoy es el último día para invertir'; }
      else { this.textDateToInvest = `Queda${daysLeftToInvest > 1 ? 'n' : ''} ${daysLeftToInvest} día${daysLeftToInvest > 1 ? 's' : ''} para invertir` }
    }
    this.getInfoPercent(this.dev);
    this.getNameSplit(this.dev?.d?.name);
  }
  
  calculateRestDay(dateLimit: number): number {
    const dateNow = new Date();
    const dateEnd = new Date(Number(dateLimit));
    const diffTime = dateEnd?.getTime() - dateNow.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (Number.isNaN(diffDays) || diffDays < 0 || diffDays == null || diffDays == undefined) {
      return 60;
    } else {
      return diffDays;
    }
  }

  calculateAutoPercent(number: number) {
    return number * 0.20;
  }

  getInfoPercent(prev: any): any {

    const total = Number(prev?.p?.total);
    const active = Number(prev?.p?.active);

    let minAmountProject = Number(prev?.p?.minAmountProject);

    if (minAmountProject == 0) {
      minAmountProject = this.calculateAutoPercent(total);
    }

    let percentMinAmount = (Number(active) / Number(minAmountProject)) * 90;
    if (prev?.p?.free == 0) {
      this.progress = 100;
      this.message = 'Proyecto fondeado';
    } else if (total == minAmountProject) {
      this.progress = (Number(active) / Number(total)) * 100;
      this.message = `${this.progress.toFixed(2)}%`;
    } else if (percentMinAmount >= 90) {
      this.progress = 90;
      this.message = 'Mínimo alcanzado';
      if (active >= minAmountProject) {
        let percentTotal = (Number(active) / Number(total)) * 100;
        if (percentTotal >= 95) {
          this.progress = percentTotal;
        }
      }
    } else if (percentMinAmount <= 90) {
      this.progress = (Number(active) / Number(minAmountProject)) * 100;
      this.message = this.progress.toFixed(2) + '%';
    }

  }

  buildImageUrl(dev: any, urlBaseS3: string): string {
    let basePath = dev?.d?.baseProject == null ? dev?.d?.pid : dev?.d?.baseProject;
    let imageUrl = dev?.d?.img?.images?.[0] || dev?.d?.gallery?.[0];

    if (!imageUrl) {
      return '';
    }

    let fullUrl = urlBaseS3 + basePath + '/' + imageUrl;
    let urlParts = fullUrl.split("https://static.monific.com/assets/");
    if (urlParts.length > 2) {
      fullUrl = "https://static.monific.com/assets/" + urlParts.pop();
    }

    return this.imageOptimizer.getOptimizedImageUrl(fullUrl, 400);

  }

  getNameSplit(devName: string) {
    let devNameParse = devName.split('-');
    if(devNameParse.length === 1) {
      this.devName = devNameParse[0];
      this.actualPhase = 1;
    } else if (devNameParse.length >= 2 ) {
      this.devName = devNameParse[0];
      this.actualPhase = Number(devNameParse[1]);
    }
  }

  getProjectStateText(state: string): string {
    const stateTextMap = {
      'variable': 'Rendimiento variable',
      'fixed': 'Rendimiento fijo',
    };

    return stateTextMap[state] || 'Rendimento variable';
  }

}
